import { AccountBalance, Event, AttachMoney, AutoFixHigh, CalendarMonth, Campaign, ClassOutlined, ConfirmationNumberOutlined, ExitToApp, Gavel, Groups, Insights, ManageAccounts, MeetingRoomOutlined, School, Settings, Store, SupportAgent, SwitchAccount, EventAvailable, EventBusy, HowToReg, AttachEmail, Delete, PeopleAlt, Public, Receipt, Edit } from "@mui/icons-material";

export const APP_ICONS = {
  ENROLMENTS: <ConfirmationNumberOutlined />,
  LOCATIONS: <Store />,
  SETTINGS: <Settings />,
  STUDENTS: <Groups />,
  CLASSES: <ClassOutlined />,
  SCHEDULE: <CalendarMonth />,
  STUDIOS: <MeetingRoomOutlined />,
  OPEN_ENROLMENTS: <AutoFixHigh />,
  SCHOOL: <School />,
  MY_PROFILE: <ManageAccounts />,
  SUPPORT: <SupportAgent />,
  SIGN_OUT: <ExitToApp />,
  CURRENCY: <AttachMoney />,
  LEGAL: <Gavel />,
  DANCE_SCHOOL_ACCOUNT: <AccountBalance />,
  ACCOUNTS: <SwitchAccount />,
  STAFF: <PeopleAlt />,
  METRICS: <Insights />,
  COMMUNICATION: <Campaign />,
  TRIALS: <Event />,
  ATTENDANCE: <HowToReg />,
  ATTENDED: <EventAvailable />,
  DID_NOT_ATTEND: <EventBusy />,
  EMAIL_SETTINGS: <AttachEmail />,
  DELETE: <Delete />,
  EDIT: <Edit />,
  PUBLIC_INFO: <Public />,
  BILLING_DETAILS: <AttachMoney />,
  INVOICES: <Receipt />
}